import React from 'react';

import { Modal } from 'redpoints-front-components/index';

import { translate } from '../../../helpers/languageHelper';

const LinksManagementAvailabilityModal = ({
  children,
  onAccept,
  onCancel,
  onSetLinkAvailability,
}) => {
  const handleAccept = () => {
    if (
      typeof onAccept === 'function' &&
      typeof onSetLinkAvailability === 'function'
    ) {
      onSetLinkAvailability();
      onAccept()();
    }
  };

  return (
    <Modal
      okText={translate('actions.confirm')}
      onCancel={onCancel}
      onOk={handleAccept}
      visible
    >
      {children}
    </Modal>
  );
};

export default LinksManagementAvailabilityModal;
